"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var qs_1 = __importDefault(require("qs"));
var axios_1 = __importDefault(require("axios"));
var mobx_1 = require("mobx");
var browser_1 = require("@sentry/browser");
var abstract_container_store_1 = __importStar(require("@hikakaku/shared/stores/estimate_form/abstract_container_store"));
var page_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/page_store"));
var estimate_form_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/estimate_form"));
var company_info_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/designated/company_info_store"));
var page_header_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/designated/page_header_store"));
var navigation_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/navigation_store"));
var form_inner_card_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/form_inner_card_store"));
var form_footer_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/form_footer_store"));
var map_name_input_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/designated/map_name_input_store"));
var item_input_card_list_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/item_input_card_list_store"));
var convert_from_input_name_1 = require("@hikakaku/shared/util/convert_from_input_name");
var mail_magazine_consent_1 = require("@hikakaku/shared/util/mail_magazine_consent");
var google_analytics_manager_1 = __importDefault(require("@hikakaku/shared/util/google_analytics_manager"));
var convert_case_keys_1 = require("@hikakaku/shared/util/convert_case_keys");
var input_card_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/input_card_store"));
var submit_page_footer_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/submit_page_footer_store"));
var barcode_reader_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/barcode_reader_store"));
var GA_EVENT_CATEGORY = 'サイト内無料見積もりフォーム';
var POST_URL = '/store_estimate_form/thanks';
var CHECK_URL = '/estimate_form/check';
var ITEM_FORM_API_URL = '/api/estimate_pages/single/item_form';
var PURCHASE_METHOD_API_URL = '/api/estimate_pages/single/purchase_method';
var ESTIMATE_DRAFT_API_URL = '/api/estimate/drafts';
var IMPORT_CATEGORY_ID_KEY = 'import_category_id';
var MAP_NAME_KEY = 'map_name';
var PURCHASE_METHOD_KEY = 'purchase_method';
var USER_CARD_INPUT_NAME_PREFIX = 'estimate_form[user]';
var CONTACT_PATH = '/お問い合わせ';
var ContainerStore = /** @class */ (function (_super) {
    __extends(ContainerStore, _super);
    function ContainerStore(props) {
        var _this = _super.call(this, props) || this;
        _this.postUrl = POST_URL;
        _this.component = estimate_form_1.default;
        _this.updateSubmitButtonsDisabled = function (disabled) {
            if (_this.submitPageFooterStore) {
                _this.submitPageFooterStore.isSubmitButtonEnabled = !disabled;
            }
        };
        _this.handleClickItemPageNextButton = function () {
            if (!_this.itemCardListStore.validate()) {
                _this.alertStore.alertText = abstract_container_store_1.ALERT_MESSAGE;
                return;
            }
            _this.checkForDuplicateItems(_this.itemCardListStore.values);
        };
        _this.proceedToNextStep = function () {
            _this.snsButtonListStore.updateOAuthPaths({
                oauth_redirect: true,
                store_id: _this.storeId,
                map_name: _this.mapNameInputStore.value,
                estimate_draft_identifier: _this.props.estimateDraftIdentifier
            });
            _this.handleClickNextPageButton();
        };
        _this.handleChangeMapName = function (mapName) {
            if (!mapName) {
                return;
            }
            _this.isLoading = true;
            var query = qs_1.default.stringify((0, convert_case_keys_1.toSnakeKeys)({ estimateForm: { storeId: _this.storeId, mapName: mapName } }));
            axios_1.default
                .get("".concat(PURCHASE_METHOD_API_URL, "?").concat(query))
                .then(function (_a) {
                var data = _a.data;
                var purchaseMethod = (0, convert_from_input_name_1.appendPrefixToInputName)(((0, convert_case_keys_1.toCamelcaseKeys)(data)), USER_CARD_INPUT_NAME_PREFIX);
                _this.userPageInputCard.replaceInputStore(purchaseMethod);
            })
                .catch(function (error) {
                window.DialogStore.showErrorDialog();
                (0, browser_1.captureException)(error);
                console.error(error);
            })
                .finally(function () {
                _this.isLoading = false;
            });
        };
        _this.itemCardInputNamePrefix = function (index) {
            return "estimate_form[items][".concat(index, "]");
        };
        _this.fetchCategoryItemInputList = function (importCategoryId) {
            if (!importCategoryId) {
                return Promise.resolve(function () { return []; });
            }
            var query = qs_1.default.stringify((0, convert_case_keys_1.toSnakeKeys)({ estimateForm: { storeId: _this.storeId, importCategoryId: importCategoryId } }));
            _this.isLoading = true;
            return axios_1.default
                .get("".concat(ITEM_FORM_API_URL, "?").concat(query))
                .then(function (response) {
                _this.isLoading = false;
                return function (cardNumber) { return (0, convert_from_input_name_1.appendPrefixToFormInputNames)(_this.assignInputGAEvent((0, convert_case_keys_1.toCamelcaseKeys)(response.data)), _this.itemCardInputNamePrefix(cardNumber)); };
            })
                .catch(function (error) {
                window.DialogStore.showErrorDialog();
                (0, browser_1.captureException)(error);
                return function () { return []; };
            });
        };
        _this.handleClickAddItemForm = function () {
            google_analytics_manager_1.default.postGAEvent(String(_this.props.gaEventCategory), '複数回査定click', "StoreID:".concat(_this.storeId));
        };
        _this.saveDraft = function () {
            var data = new FormData();
            var appendToFormData = function (_a) {
                var name = _a.name, value = _a.value;
                if (value === undefined || value === null) {
                    return;
                }
                if (Array.isArray(value)) {
                    value.forEach(function (v) { return data.append(name, v); });
                }
                else {
                    data.append(name, String(value));
                }
            };
            data.append('form', 'store_estimate_form');
            data.append('reason', 'abandonment');
            _this.props.estimateDraftIdentifier && data.append('estimate_form[estimate_draft_identifier]', _this.props.estimateDraftIdentifier);
            _this.storeId && data.append('estimate_form[store_id]', String(_this.storeId));
            _this.mapNameInputStore.value && data.append(_this.mapNameInputStore.name, _this.mapNameInputStore.value);
            _this.itemCardListStore.values.flatMap(Object.values).forEach(appendToFormData);
            var purchaseMethodInputStore = _this.userPageInputCard.findInputStoreByRawName(PURCHASE_METHOD_KEY);
            (purchaseMethodInputStore === null || purchaseMethodInputStore === void 0 ? void 0 : purchaseMethodInputStore.value) && appendToFormData({ name: purchaseMethodInputStore.name, value: purchaseMethodInputStore.value });
            axios_1.default.post(ESTIMATE_DRAFT_API_URL, data);
        };
        _this.validate = function () {
            return _this.itemCardListStore.validate() && _this.userPageInputCard.validate();
        };
        _this.handleModalButtonClick = function () {
            window.location.href = CONTACT_PATH;
        };
        _this.gaEventCategory = GA_EVENT_CATEGORY;
        _this.snsButtonListStore.formPath = POST_URL;
        _this.hiddenFieldInputListStore.addHiddenField({ name: 'authenticity_token', value: props.authenticityToken }, { name: 'estimate_form[store_id]', value: String(props.storeId) }, { name: 'estimate_form[estimate_draft_identifier]', value: props.estimateDraftIdentifier });
        var pageHeaderStore = new page_header_store_1.default();
        var companyInfoStore = new company_info_store_1.default({ companyInfo: props.companyInfo });
        var formFooterStore = new form_footer_store_1.default({
            showsNextButton: true,
            onClickNextButton: _this.handleClickItemPageNextButton,
            description: 'あと少しで入力完了！'
        });
        _this.mapNameInputStore = new map_name_input_store_1.default({
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            inputProps: (0, convert_from_input_name_1.appendPrefixToInputName)(props.userForm.find(function (_a) {
                var name = _a.name;
                return name === MAP_NAME_KEY;
            }), USER_CARD_INPUT_NAME_PREFIX),
            onChange: _this.handleChangeMapName
        });
        var defaultItemInputProps = props.defaultItemForm
            ? function (cardNumber) { return ((0, convert_from_input_name_1.appendPrefixToFormInputNames)(_this.assignInputGAEvent(props.defaultItemForm), _this.itemCardInputNamePrefix(cardNumber))); }
            : undefined;
        _this.itemCardListStore = new item_input_card_list_store_1.default({
            categorySelectorOptions: props.categorySelectorOptions,
            itemCardInputProps: props.itemForms.map(function (itemForm) { return function (cardNumber) { return ((0, convert_from_input_name_1.appendPrefixToFormInputNames)(_this.assignInputGAEvent(itemForm), _this.itemCardInputNamePrefix(cardNumber))); }; }),
            fetchCategoryItemInputList: _this.fetchCategoryItemInputList,
            onClickAddItemButton: _this.handleClickAddItemForm,
            defaultImportCategoryGroupId: props.importCategoryGroupId ? String(props.importCategoryGroupId) : undefined,
            defaultImportCategoryId: props.importCategoryId ? String(props.importCategoryId) : undefined,
            defaultItemInputProps: defaultItemInputProps
        });
        _this.userPageInputCard = new input_card_store_1.default({
            title: 'お客様情報',
            inputProps: (0, mail_magazine_consent_1.insertMailMagazineConsentInput)((0, convert_from_input_name_1.appendPrefixToFormInputNames)(props.userForm.filter(function (_a) {
                var name = _a.name;
                return name !== MAP_NAME_KEY;
            }), USER_CARD_INPUT_NAME_PREFIX), props.mailMagazineConsent)
        });
        var submitPageFooterStore = new submit_page_footer_store_1.default({
            onClickSubmitButton: _this.handleClickSubmitButton,
            onClickPrevButton: _this.handleClickPrevPageButton
        });
        _this.submitPageFooterStore = submitPageFooterStore;
        var barcodeReaderStore = new barcode_reader_store_1.default({
            itemInputCardListStore: _this.itemCardListStore
        });
        _this.storeId = props.storeId;
        _this.pageStores = [
            new page_store_1.default({
                elementStores: [
                    pageHeaderStore,
                    companyInfoStore,
                    _this.alertStore,
                    new navigation_store_1.default({ step: 1 }),
                    new form_inner_card_store_1.default({
                        elementStores: [
                            barcodeReaderStore,
                            _this.mapNameInputStore,
                            _this.itemCardListStore,
                            _this.alertStore,
                            formFooterStore
                        ]
                    })
                ]
            }),
            new page_store_1.default({
                elementStores: [
                    pageHeaderStore,
                    companyInfoStore,
                    _this.alertStore,
                    new navigation_store_1.default({ step: 2 }),
                    _this.snsButtonListStore,
                    new form_inner_card_store_1.default({
                        elementStores: [
                            _this.userPageInputCard,
                            _this.alertStore,
                            submitPageFooterStore
                        ]
                    })
                ]
            })
        ];
        (0, mobx_1.reaction)(function () { return _this.itemCardListStore.values; }, _this.alertStore.clear);
        (0, mobx_1.reaction)(function () { return _this.isLoading; }, function (isLoading) { formFooterStore.isNextButtonEnabled = !isLoading; });
        (0, mobx_1.reaction)(function () { return _this.isSending; }, function (isSending) { isSending && submitPageFooterStore.prepareSubmit(); });
        (0, mobx_1.reaction)(function () { return _this.currentPage; }, function () { barcodeReaderStore.active = false; });
        return _this;
    }
    ContainerStore.prototype.checkForDuplicateItems = function (values) {
        return __awaiter(this, void 0, Promise, function () {
            var names, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        names = values.map(function (item) { return item.name.value; });
                        return [4 /*yield*/, axios_1.default.post(CHECK_URL, { names: names })];
                    case 1:
                        response = _a.sent();
                        response.data.isDuplicate ? this.showModal() : this.proceedToNextStep();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        this.proceedToNextStep();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return ContainerStore;
}(abstract_container_store_1.default));
exports.default = ContainerStore;
